import { getZoneJsOriginalValue } from '../tools/getZoneJsOriginalValue';
import { monitor } from '../tools/monitor';
export function setTimeout(callback, delay) {
    return getZoneJsOriginalValue(window, 'setTimeout')(monitor(callback), delay);
}
export function clearTimeout(timeoutId) {
    getZoneJsOriginalValue(window, 'clearTimeout')(timeoutId);
}
export function setInterval(callback, delay) {
    return getZoneJsOriginalValue(window, 'setInterval')(monitor(callback), delay);
}
export function clearInterval(timeoutId) {
    getZoneJsOriginalValue(window, 'clearInterval')(timeoutId);
}
//# sourceMappingURL=timer.js.map